module.exports = __webpack_public_path__ + "img/ADA.e1387e30.svg";